import { ActionTree } from "vuex"

import { SohoModel } from "~/constants/SohoModel"
import { RequestParameters } from "~/utils/SohoApi/SohoApi"
import { setIncludedResources } from "~/utils/store"

import { RootState } from "../store.types";
import {
  AvailabilitiesFilter,
  AvailabilitiesState,
  Availability,
  AvailabilityResource,
  AvailabilityFilter
} from "~/store/availabilities/availabilities.types"

const actions: ActionTree<AvailabilitiesState, RootState> = {
  async fetchAvailabilities ({ commit }, params: RequestParameters<Availability, AvailabilitiesFilter> = {}) {
    commit("DELETE_AVAILABILITIES")

    const { data, included } = await this.$sohoApi.get<AvailabilityResource>(SohoModel.Availability, {
      include: ['room', 'availability_rates', 'availability_rates.rate_plan', 'default_availability_rate'],
      filter: {
        ...params,
        page: 1,
        perPage: 100
      },
    })

    // Optionally set the included resources
    if (included) {
      setIncludedResources(included, commit)
    }

    if (data) {
      commit("SET_AVAILABILITIES", { params, data })
    }
  },

  async fetchAvailability ({ commit }, params: RequestParameters<Availability, AvailabilityFilter> = {}) {
    const { data, included } = await this.$sohoApi.get<AvailabilityResource>(`${SohoModel.Availability}/${params.id}`, {
      include: ['room', 'availability_rates', 'availability_rates.rate_plan', 'default_availability_rate']
    })

    // Optionally set the included resources
    if (included) {
      setIncludedResources(included, commit)
    }

    if (data) {
      commit("SET_AVAILABILITY", data)
    }
  }
}

export default actions
